<template>
  <article class="sale-count">
    <ul class="tab-service-detail">
      <li v-for="(item, index) in tabList" @click="onShiftTab(item)" :class="{on:item.on}" :key="index">
        <a href="javascript:void(0);">{{item.name}}</a>
      </li>
    </ul>
    <div class="blank"></div>
    <div class="car-all">
      <cell :title="storeInfo.current.store_name" class="top-title" v-if="tabList[0].on && tabList[0].id === 'date'">
        <span slot="after-title" class="title-date">{{"|&nbsp;&nbsp;" + day}}</span>
        <button
          slot="child"
          @click="tabChange({filter: 'today', bool: true})"
          :class="{'btn-select': flagA, 'btn-default': !flagA}">今天</button>
        <button
          slot="child"
          @click="tabChange({filter: 'yestoday', bool: false})"
          :class="[{'btn-select': !flagA, 'btn-default': flagA}, 'btn-margin']">昨天</button>
      </cell>
      <cell :title="storeInfo.current.store_name" class="top-title" v-else>
        <span slot="after-title" class="title-date">{{"|&nbsp;&nbsp;" + day}}</span>
        <button
          slot="child"
          @click="tabChange({filter: 'this_month', bool: true})"
          :class="{'btn-select': flagA, 'btn-default': !flagA}">本月</button>
        <button
          slot="child"
          @click="tabChange({filter: 'last_month', bool: false})"
          :class="[{'btn-select': !flagA, 'btn-default': flagA}, 'btn-margin']">上个月</button>
      </cell>
      <p class="table-title">
        到店客户转成交漏斗
        <router-link
          class="go-detail"
          :to="{path: '/saleAnalysis/shopCustomers', query: {store_id: params.store_id, type: num}}">
          查看详情
        </router-link>
      </p>
      <group class="diagram-analysis-dl diagram-dl-one">
        <cell class="one">
          <p slot="after-title"><span>到店量(客流)</span><em class="p-em">{{ storeInfo.arrive_to_deal.arrived }}</em></p>
        </cell>
        <cell class="two">
          <p slot="after-title"><span>草签数</span><em class="p-em">{{ storeInfo.arrive_to_deal.review }}</em></p>
        </cell>
        <cell class="three">
          <p slot="after-title">
            <span>成交数</span>
            <em class="p-em">{{ storeInfo.arrive_to_deal.deal }}</em>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;成交率{{ storeInfo.arrive_to_deal.deal_rate * 100 }}%</span>
          </p>
        </cell>
      </group>
      <p class="table-title">
        销售顾问业绩
        <router-link
          class="go-detail"
          :to="{path: '/saleAnalysis/salesConsultant', query: {store_id: params.store_id, type: num}}">
          查看详情
        </router-link>
      </p>
      <div class="count-table" v-if="tabList[1].on && tabList[1].id === 'month'">
        <div class="count-item">
          <h5>{{ storeInfo.sale.booked }}</h5>
          <em>预约到店</em>
        </div>
        <div class="count-item count-border">
          <h5>{{ storeInfo.sale.reception }}</h5>
          <em>接待量</em>
        </div>
        <div class="count-item">
          <h5>{{ storeInfo.sale.new_reception }}</h5>
          <em>新增接待</em>
        </div>
        <div class="line"></div>
        <div class="count-item">
          <h5>{{ storeInfo.sale.review }}</h5>
          <em>草签数</em>
        </div>
        <div class="count-item count-border">
          <h5>{{ storeInfo.sale.deal }}</h5>
          <em>成交数</em>
        </div>
      </div>
      <div class="count-table" v-else>
        <div class="count-item">
          <h5>{{ storeInfo.sale.phone }}</h5>
          <em>电话任务</em>
        </div>
        <div class="count-item count-border">
          <h5>{{ storeInfo.sale.booked }}</h5>
          <em>预约到店</em>
        </div>
        <div class="count-item">
          <h5>{{ storeInfo.sale.reception }}</h5>
          <em>接待量</em>
        </div>
        <div class="line"></div>
        <div class="count-item">
          <h5>{{ storeInfo.sale.new_reception }}</h5>
          <em>新增接待</em>
        </div>
        <div class="count-item count-border">
          <h5>{{ storeInfo.sale.review }}</h5>
          <em>草签数</em>
        </div>
        <div class="count-item">
          <h5>{{ storeInfo.sale.deal }}</h5>
          <em>成交数</em>
        </div>
      </div>
      <p class="table-title">
        潜客线索到店转成交漏斗
        <router-link
          class="go-detail"
          :to="{path: '/saleAnalysis/dccclues',
          query: {store_id: params.store_id, type: num}}">
          查看详情
        </router-link>
      </p>
      <group class="diagram-analysis-dl diagram-dl-two">
        <cell class="one">
          <p slot="after-title"><span>线索合计</span><em class="p-em">{{ storeInfo.clue_to_deal.clue }}</em></p>
        </cell>
        <cell class="two">
          <p slot="after-title">
            <span>到店合计</span>
            <em class="p-em">{{ storeInfo.clue_to_deal.arrived }}</em>
            <span>到店率: {{ storeInfo.clue_to_deal.arrived_rate * 100 }}%</span>
          </p>
        </cell>
        <cell class="three">
          <p slot="after-title">
            <span>成交合计</span>
            <em class="p-em">{{ storeInfo.clue_to_deal.deal }}</em>
            <span class="rates">
              &nbsp;&nbsp;成交率：{{ storeInfo.clue_to_deal.deal_rate * 100 }}% <br />
              &nbsp;&nbsp;到店成交率：{{ storeInfo.clue_to_deal.arrived_to_deal_rate * 100 }}%
            </span>
          </p>
        </cell>
      </group>
      <p class="table-title">
        DCC跟进概况
        <router-link
          class="go-detail"
          :to="{path: '/saleAnalysis/dccFollowUp', query: {store_id: params.store_id, type: num}}">
          查看详情
        </router-link>
      </p>
      <div class="count-table" v-if="tabList[1].on && tabList[1].id === 'month'">
        <div class="count-item">
          <h5>{{ storeInfo.dcc.contacted }}</h5>
          <em>已联系</em>
        </div>
        <div class="count-item count-border">
          <h5>{{ storeInfo.dcc.booked }}</h5>
          <em>已预约</em>
        </div>
        <div class="count-item">
          <h5>{{ storeInfo.dcc.arrived }}</h5>
          <em>已到店</em>
        </div>
        <div class="line"></div>
        <div class="count-item">
          <h5>{{ storeInfo.dcc.dealed }}</h5>
          <em>已成交</em>
        </div>
        <div class="count-item count-border">
          <h5>{{ storeInfo.dcc.defeated }}</h5>
          <em>已战败</em>
        </div>
      </div>
      <div class="count-table" v-else>
        <div class="count-item">
          <h5>{{ storeInfo.dcc.today_follow_up }}</h5>
          <em>今日待跟进</em>
        </div>
        <div class="count-item count-border">
          <h5>{{ storeInfo.dcc.today_to_arrive }}</h5>
          <em>今日待到店</em>
        </div>
        <div class="count-item">
          <h5>{{ storeInfo.dcc.not_contacted }}</h5>
          <em>未联系</em>
        </div>
        <div class="line"></div>
        <div class="count-item">
          <h5>{{ storeInfo.dcc.contacted }}</h5>
          <em>已联系</em>
        </div>
        <div class="count-item count-border">
          <h5>{{ storeInfo.dcc.booked }}</h5>
          <em>已预约</em>
        </div>
        <div class="count-item">
          <h5>{{ storeInfo.dcc.arrived }}</h5>
          <em>已到店</em>
        </div>
        <div class="line"></div>
        <div class="count-item">
          <h5>{{ storeInfo.dcc.dealed }}</h5>
          <em>已成交</em>
        </div>
        <div class="count-item count-border">
          <h5>{{ storeInfo.dcc.defeated }}</h5>
          <em>已成交</em>
        </div>
      </div>
    </div>
  </article>
</template>
<script>
import util from '../../common/util'
import {
  Cell,
  Group
} from '@lx-frontend/cvux'
export default {
  components: {
    Cell,
    Group
  },
  data () {
    return {
      storeId: '',
      flagA: true,
      num: this.$route.query.type,
      params: {
        filter: 'this_month',
        store_id: this.$route.query.store_id
      },
      day: util.formatTime(new Date(), 'yyyy-MM'), // 获取当前日期
      tabList: [{
        id: 'date',
        name: '日',
        on: false
      }, {
        id: 'month',
        name: '月',
        on: true
      }],
      storeInfo: {
        current: {},
        sale: {},
        dcc: {},
        arrive_to_deal: {},
        clue_to_deal: {}
      }
    }
  },
  created () {
    this.getData()
    this.getType()
  },
  methods: {
    getType () {
      const type = this.$route.query.type
      let index = 1

      if (type) {
        index = parseFloat(type)
      }

      this.onShiftTab(this.tabList[index])
    },
    onShiftTab (item) {
      this.tabList.forEach((tab) => {
        if (item.id === tab.id) {
          tab.on = true
        } else {
          tab.on = false
        }
      })
      if (item.on && item.id === 'date') {
        this.day = util.formatTime(new Date(), 'yyyy-MM-dd')
        this.flagA = true
        this.num = 0
        this.params.filter = 'today'
        this.getData()
        this.getCurrentTime()
      } else {
        this.day = util.formatTime(new Date(), 'yyyy-MM-dd')
        this.flagA = true
        this.num = 1
        this.params.filter = 'this_month'
        this.getData()
        this.getCurrentTime()
      }
    },
    tabChange (newParams) {
      this.params.filter = newParams.filter
      this.flagA = newParams.bool
      this.getData()
      this.getCurrentTime()
    },
    getData () {
      this.$rest.dataAnalysis.getStoreSummary(this.params).then(res => {
        if (res.code === 0) {
          this.storeInfo = res.data
        } else {
          this.showToast(res.message)
        }
      })
    },
    getCurrentTime () {
      let date = new Date()
      switch (this.params.filter) {
        case 'last_month':
          let lastMonty = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate())
          this.day = util.formatTime(lastMonty, 'yyyy-MM')
          break
        case 'yestoday':
          let yesterday = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1)
          this.day = util.formatTime(yesterday, 'yyyy-MM-dd')
          break
        case 'today':
          this.day = util.formatTime(date, 'yyyy-MM-dd')
          break
        default:
          this.day = util.formatTime(date, 'yyyy-MM')
      }
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
  @import "../../stylesheets/modules/data/carData.less";
  .sale-count {
    .table-title {
      margin-right: 0.4rem;
    }
    .go-detail {
      float: right; color: #5890ff
    }
    .rates {
      line-height: 0.6rem !important;
      text-align: left;
    }
    .count-table {
      margin: 0.4rem;
      border: 1px solid #ccc;
      .line {
        border-bottom: 1px solid #ccc;
      }
      .count-item {
        width: 32%;
        text-align: center;
        display: inline-block;
        margin: 20/@w2 0;
        h5 {
          font-size: 40/@w2;
          margin-bottom: 20/@w2;
        }
        em {
          color: #999;
        }
      }
      .count-border {
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
      }
    }
    .diagram-analysis-dl{
      margin-left: 30/@w2;
      margin-top: 30/@w2;
      .weui_cells{
        margin-top: -10/@w2;
        &::before{
          display: none;
        }
        &::after{
          left: 30/@w2;
        }
      }
      .weui_cell{
        padding: 0 0 0 0.4rem;
        &::before{
          z-index: 11;
        }
      }

      .one em.p-em{
        margin-left: 0;
      }
      .two em.p-em{
        margin-left: 16/@w2;
      }
      .three em.p-em{
        margin-left: 32/@w2;
      }
      em{
        font-size: 26/@w2;
        text-align: center;
        position: relative;
        &:before,&:after{
          content: "";
          position: absolute;
          background: url("../../stylesheets/images/manage/triangle.png") no-repeat;
          width: 16/@w2;
          height:96/@w2;
          background-size:100% 100%;
          top:0;
        }
        &:before{
          left: 0;
        }
        &:after{
          right: 0;
          -webkit-transform: scale(-1,1);
        }
      }

      .title{
        em,span {
          color: #5b6984;
        }
        span{
          display: inline-block; width: 158/@w2;
        }
      }
      .one {
        em{ background: #d7e3ff; display: inline-block; width: 283/@w2;
          margin-left: 0 }
      }
      .two {
        em{ background: #e3ebff; display: inline-block; width: 251/@w2;
          margin-left: 16/@w2;}
      }
      .three {
        em{ background: #f3f6ff; display: inline-block; width: 219/@w2;
          margin-left: 70/@w2;}
      }
      .deal-rate {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        line-height: normal;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p > span{
        &:first-child {
          display: inline-block;
          width: 228/@w2;
          text-indent: 30/@w2;
          color: #5b6984;
        }
        &:first-child, &:last-child {
          font-size: 26/@w2;
        }
      }
      span,em{ float: left;line-height: 96/@w2;}
      em{width: 234/@w2; line-height: 96/@w2;
        position: relative;}
      .weui_cell {
        padding: 0;
        margin-right: 30/@w2;
        border-bottom: 1px solid #D9D9D9;
      }
      .weui_cell:before {
        left: 0;
        border-top: 0;
      }
    }
    .diagram-dl-two {
      p > span:nth-child(1) {
        width: 158/@w2;
      }
    }
  }

</style>
